// Module
var code = "<div data-control-type=\"colorselector-control\" class=\"ToolBarPreview\"> <label data-bind=\"attr: { title: Label }\"> <i class=\"fa fa-paint-brush\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div> ";
// Exports
export default code;